import Types from "@Types";

const reducer = (state = [], action) => {
  switch (action.type) {
    //? inset Customer
    case Types.Survey.insert:
      return [...state, action.payload.value];
    //? update Customer
    case Types.Survey.update:
      return [
        ...state.map((x) => {
          if (x.Series === action.payload.Series) return action.payload.value;
          else return x;
        }),
      ];
    //? delete Customer
    case Types.Survey.delete:
      return [...state.filter((x) => x.Series !== action.payload.Series)];
    // ? clear all data
    case Types.clear:
      return [];
    //? set Customer
    case Types.Survey.set:
      return action.payload ?? [];
    // ? default
    default:
      return state;
  }
};

export default reducer;
